import { Color, Vector2 } from 'three';

// TODO: We should replace this with `<SimpleBlobBg />`.
export const blobs = [
    {
        edge: 0,
        scale: 0.7,
        color: new Color(0x060c50),
        errorColor: new Color(0x9c0c6b),
        distortionAmount: 2,
        position: new Vector2(0, 1),
    },
    {
        edge: 0,
        scale: 0.5,
        color: new Color(0x3a0d36),
        errorColor: new Color(0xb72096),
        distortionAmount: 2,
        position: new Vector2(1, 0),
    },
    {
        edge: 0,
        scale: 0.7,
        color: new Color(0x3b0b6b),
        errorColor: new Color(0x860026),
        distortionAmount: 2,
        position: new Vector2(0.5, -0.2),
    },
    {
        edge: 0,
        scale: 0.4,
        color: new Color(0x4f305c),
        errorColor: new Color(0xff0541),
        distortionAmount: 2,
        position: new Vector2(1, 1),
    },
    {
        edge: 0,
        scale: 0.3,
        color: new Color(0x202a4f),
        errorColor: new Color(0xee0a4a),
        distortionAmount: 2,
        position: new Vector2(0, 0),
    },
];
